import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'

export const BlogSEO = (props: LevelProps) => {
  const isVirtualMarketer = useCurrentWorkspace()?.is_virtual_marketer

  return (
    <LevelPage
      {...props}
      imgScale={0.45}
      cards={LEVEL_CARDS.L2.BLOG_SEO.filter((card) => !isVirtualMarketer || card.wizard !== GenerationType.SEOPlanning)}
    />
  )
}
